import { INDEXES, getColorThemesForProduct } from '../constants/colors';
import { getOffsets } from './indexOffsets';

export function removeCategoryColumn(data) {
  const { series } = data;
  const { seriesOffset } = getOffsets(data);
  return [series.slice(seriesOffset), seriesOffset];
}

export function findColors(series, offset, product, themeName, econDataTheme, origSeries = []) {
  // for market data charts with stocks and indexes, set index color to gray

  const [hasStocks, hadStocks] = [series, origSeries].map(checkStocks);
  let numIndexes = 0;
  return function (currentSeries, index) {
    const origIdx = origSeries.findIndex(
      (currentOrigSeries) => currentOrigSeries.symbol === currentSeries.symbol
    );
    const origTicker = origSeries[origIdx] || {};

    const [isIndex, wasIndex] = [currentSeries, origTicker].map(checkIndex);

    const needsGray = hasStocks && isIndex;
    const neededGray = hadStocks && wasIndex;
    const color = checkColor(
      origSeries,
      origIdx,
      neededGray,
      origTicker,
      themeName,
      product,
      isIndex
    )
      ? origTicker.color
      : getColorProp(themeName, product, index - numIndexes, numIndexes, needsGray, econDataTheme);
    const negativeColor =
      origTicker.negativeColor || getNegativeColorProp(themeName, product, index + 1);
    const seriesIdx = index + offset;

    if (needsGray) numIndexes++;

    return { color, negativeColor, seriesIdx };
  };
}

export function getColorTheme(themeName, product, econDataTheme) {
  const theme = getColorThemesForProduct(product);
  const colorTheme =
    theme[econDataTheme] ||
    theme[themeName] ||
    (product === 'wsj' && theme.wsj_world) ||
    theme[product] ||
    theme.barrons;
  return colorTheme.theme;
}

function checkStocks(tickers) {
  return tickers.some((ticker) => ticker.tickerType === 'Stock');
}

function checkIndex(series) {
  return series.tickerType === 'Index';
}

function checkColor(origSeries, origIdx, neededGray, origTicker, themeName, product, isIndex) {
  const indexTheme = themeName === 'wsj_video' ? themeName : product;
  const origNumIndexes = countIndexes(origSeries, origIdx);
  const { color } = origTicker;
  const offset = isIndex ? 0 : origNumIndexes;
  const themeColor = getColor(getColorTheme(themeName, product), origIdx - offset);
  const indexColor = getColor(INDEXES[indexTheme], origNumIndexes);
  const themeColorNotMatched = !neededGray && color !== themeColor;
  const indexColorNotMatched = neededGray && color !== indexColor;
  return color && (themeColorNotMatched || indexColorNotMatched);
}

function countIndexes(origSeries, origIdx) {
  let origNumIndexes = 0;
  for (let i = 0; i < origIdx; i++) {
    if (checkIndex(origSeries[i])) origNumIndexes++;
  }
  return origNumIndexes;
}

function getColor(colors, index) {
  return colors[index % colors.length];
}

function getColorProp(theme, product, index, numIndexes, needsGray, econDataTheme) {
  const indexTheme = theme === 'wsj_video' ? theme : product;
  const [colorTheme, seriesIdx] = needsGray
    ? [INDEXES[indexTheme], numIndexes]
    : [getColorTheme(theme, product, econDataTheme), index];
  return getColor(colorTheme, seriesIdx);
}

function getNegativeColorProp(theme, product, index) {
  return getColor(getColorTheme(theme, product), index);
}
